import React from "react";
import payByBLIK from "iconsTwoColors/cx/pay-by-blik.png";

export default function PayByBLIK() {
  return <img src={payByBLIK} alt="BLIK" height={18} title="BLIK" />;
}
